import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [
    { id: 1, src: '/images/ourfleet/8.jpg', alt: 'Image 1' },
    { id: 2, src: '/images/ourfleet/1.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/ourfleet/10.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/ourfleet/2.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/ourfleet/3.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/ourfleet/4.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/ourfleet/5.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/6.jpg', alt: 'Image 6' },

    { id: 6, src: '/images/ourfleet/7.jpg', alt: 'Image 6' },
   
    { id: 6, src: '/images/ourfleet/9.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/9.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/9.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/ourfleet/10.jpg', alt: 'Image 6' },

   
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Gallery - Mauli Cabs",
    "url": "https://www.maulicabs.in/gallery",  // Replace with actual URL
    "description": "Explore the gallery of Mauli Cabs showcasing our fleet, satisfied customers, and comfortable rides between Mumbai and Pune. View images of our vehicles and service in action."
  };
  

  
  return (

<>
<Helmet>
    <title>Gallery | Mauli Cabs | Photos of Our Fleet and Services</title>
    <meta
      name="description"
      content="Browse Mauli Cabs' gallery featuring our fleet of vehicles, happy passengers, and high-quality service for Mumbai to Pune travel. See images of our cabs, drivers, and more."
    />
    <meta
      name="keywords"
      content="mauli cabs gallery, mauli cabs fleet images, mumbai pune taxi photos, taxi service gallery, innova crysta images, ertiga cab pictures, mauli cabs vehicles, mauli cabs fleet, cab service gallery, mumbai to pune travel images"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

  <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <img
          src="/img/icons/cloud.png"
          alt="vs-breadcrumb-icon"
          className="vs-breadcrumb-icon-1 animate-parachute"
        />
        <img
          src="/img/icons/ballon-sclation.png"
          alt="vs-breadcrumb-icon"
          className="vs-breadcrumb-icon-2 animate-parachute"
        />
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Gallery</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

    
    <div className="gallery-container ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;